import {Vue} from 'ui.vue';
import {Vuex} from 'ui.vue.vuex';


import './BXmakerAuthuseremailSimpleCode.css';

import '../BXmakerAuthuseremailInputCode';
import '../BXmakerAuthuseremailButton';
import '../BXmakerAuthuseremailHeader';
import '../BXmakerAuthuseremailMessage';
import '../BXmakerAuthuseremailTimeout';
import '../BXmakerAuthuseremailLink';
import '../BXmakerAuthuseremailCaptcha';

/**
 * @emits onClickChangeEmail {} - клик по кнопке изменить email
 */
Vue.component('BXmakerAuthuseremailSimpleCode',
    {
        props: [
            'data',
        ],
        data: function () {
            return {
                'lastActionSendCode': true, //последняя операция была - отправить новый код
            };
        },
        mounted(){
            this.$refs.refInputCode.focus();
        },
        computed: {
            ...Vuex.mapState('bxmaker/authuseremail/simple', [
                'email', 'message', 'error',
                'sendCodeLoader', 'sendCodeTimeout',
                'checkCodeLoader',
                'codeLength' ,  'code', 'codeError',
                'captchaSrc','captchaWord','captchaLength','captchaLoader',
            ]),
        },
        methods: {
            onInputCode(value) {
                this.$store.commit('bxmaker/authuseremail/simple/setCode', value);
                this.$store.commit('bxmaker/authuseremail/simple/setCodeError', false);

                if(this.codeLength == value.length)
                {
                    this.onEnterCode();
                }
            },
            onEnterCode() {
                this.lastActionSendCode = false;
                this.$store.dispatch('bxmaker/authuseremail/simple/checkCode');
            },
            onClickChangeEmail() {
                this.lastActionSendCode = true;
                this.$emit('onClickChangeEmail');
            },
            onClickSendCode(){
                this.lastActionSendCode = true;
                this.$store.commit('bxmaker/authuseremail/simple/setCode', '');
                this.$store.commit('bxmaker/authuseremail/simple/setCodeError', false);

                this.$store.dispatch('bxmaker/authuseremail/simple/sendCode');
            },
            onInputCaptcha(value){
                this.$store.commit('bxmaker/authuseremail/simple/setCaptchaWord', value);
            },
            onClickRefreshCaptcha(){
                this.$store.dispatch('bxmaker/authuseremail/simple/captchaRefresh');
            },
            onCompleteCaptcha(){
                //повторяем операцию последнюю
                if(this.lastActionSendCode)
                {
                    this.onClickSendCode();
                }
                else
                {
                    this.onEnterCode();
                }
            },
            onCompleteTimeout(){
                this.$store.commit('bxmaker/authuseremail/simple/setSendCodeTimeout', 0);
            }
        },
        template: `
            <div class="bxmaker-authuseremail-simple-code"  >
                <BXmakerAuthuseremailHeader>
                    {{$root.localize.BXMAKER_AUTHUSEREMAIL_CHECK_CODE_BLOCK_TITLE}}
                </BXmakerAuthuseremailHeader>     
                
                <BXmakerAuthuseremailMessage :message="message" :error="error" />                     
                    
                <div class="bxmaker-authuseremail-simple-code__notice">
                     {{$root.localize.BXMAKER_AUTHUSEREMAIL_CHECK_CODE_BLOCK_NOTICE}} 
                     
                     <span class="bxmaker-authuseremail-simple-code__email">{{email}}</span>
                     
                     <BXmakerAuthuseremailLink @onClick="onClickChangeEmail">
                        {{$root.localize.BXMAKER_AUTHUSEREMAIL_CHECK_CODE_BLOCK_CHANGE_EMAIL}}
                     </BXmakerAuthuseremailLink>                     
                </div>
                
                <BXmakerAuthuseremailInputCode 
                    :value="code" 
                    @onInput="onInputCode" 
                    @onEnter="onEnterCode" 
                    ref="refInputCode" 
                    :maxLength="codeLength"  
                    :loader="checkCodeLoader"
                    :validationMessage="codeError"
                />
                               
                
                <BXmakerAuthuseremailCaptcha 
                    :src="captchaSrc"
                    :word="captchaWord"
                    :length="captchaLength"
                    :loader="captchaLoader"                    
                    @onClickRefresh="onClickRefreshCaptcha"
                    @onInput="onInputCaptcha"
                    @onComplete="onCompleteCaptcha"
                     />                 
                                 
                <BXmakerAuthuseremailTimeout :timeout="sendCodeTimeout" v-if="sendCodeTimeout" @onComplete="onCompleteTimeout" />                
                
                <div class="bxmaker-authuseremail-simple-code__send" v-else>
                    <BXmakerAuthuseremailLink @onClick="onClickSendCode" v-if="!sendCodeLoader">
                        {{$root.localize.BXMAKER_AUTHUSEREMAIL_CHECK_CODE_BLOCK_GET_NEW_CODE}}   
                     </BXmakerAuthuseremailLink> 
                     <BXmakerAuthuseremailLoader class="bxmaker-authuseremail-simple-code__send-loader" v-else />
                </div>
                
                                
            </div>
        `,
    });